import { commonRequest } from "../../../services/ApiCall";
import { Helpers } from "../../../services/Helpers";

export const ExpertMapServices = {
    getCategoryList: async () => {
        return await commonRequest("get", `${Helpers.URL()}/api/v2/admin/experts/getCategories`, {}, Helpers.token());
    },
    getSubCategoryList: async (categoryId) => {
        return await commonRequest("get", `${Helpers.URL()}/api/v2/admin/experts/getSubCategories/${categoryId}`, {}, Helpers.token());
    },
    getServicesBySubcategory: async (subcategoryId) => {
        return await commonRequest("get", `${Helpers.URL()}/api/v2/admin/experts/getServicesBySubcategory/${subcategoryId}`, {}, Helpers.token());
    },
    getExpertList: async (data) => {
        console.log("data:", data);
        const queryParams = new URLSearchParams();
        // Add parameters from data object to queryParams
        if (data.categoryId) queryParams.append("categoryId", data.categoryId);
        if (data.subcategoryId) queryParams.append("subcategoryId", data.subcategoryId);
        if (data.masterServiceId) queryParams.append("masterServiceId", data.masterServiceId);
        if (data.childServiceId) queryParams.append("childServiceId", data.childServiceId);
        console.log("queryParams",queryParams.toString());
        return await commonRequest("GET",  `${Helpers.URL()}/api/v2/admin/experts/getExpertList?${queryParams.toString()}`,{}, Helpers.token());
    },
}